import StarfieldCanvas from "./StarfieldCanvas";
import MaskedLines from "./MaskedLines";
import Reveal from "./Reveal";

export default function PageHero({
  eyebrow,
  lines,
  description,
  image,
  imageAlt,
  imageAspect = "aspect-[4/5]",
  meta,
}) {
  return (
    <header className="relative overflow-hidden border-b border-white/[0.06]">
      <StarfieldCanvas
        className="absolute inset-0 h-full w-full"
        interactive={false}
      />
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(139,92,246,0.12),transparent_60%)]"
        aria-hidden="true"
      />
      <div className="relative mx-auto grid max-w-7xl gap-12 px-5 pb-16 pt-32 sm:px-8 sm:pb-20 sm:pt-40 lg:grid-cols-12 lg:gap-10 lg:px-10 lg:pb-24 lg:pt-44">
        <div className={image ? "lg:col-span-7" : "lg:col-span-9"}>
          <p className="eyebrow">{eyebrow}</p>
          <h1 className="font-display mt-6 font-light leading-[1.05] tracking-tight text-[clamp(2.1rem,6.5vw,4rem)]">
            <MaskedLines lines={lines} />
          </h1>
          <Reveal delay={0.55}>
            <p className="body-muted mt-8 max-w-xl text-base sm:text-lg">
              {description}
            </p>
          </Reveal>
          {meta && (
            <Reveal delay={0.7}>
              <p className="coordinate-badge mt-8">{meta}</p>
            </Reveal>
          )}
        </div>
        {image && (
          <Reveal delay={0.35} y={40} className="lg:col-span-5">
            <div className="relative">
              <div
                className="absolute -inset-6 bg-[#8B5CF6]/10 blur-3xl"
                aria-hidden="true"
              />
              <figure className="relative overflow-hidden border border-white/10">
                <img
                  src={image}
                  alt={imageAlt || ""}
                  className={`${imageAspect} w-full object-cover`}
                  loading="eager"
                />
                <div
                  className="absolute inset-0 bg-gradient-to-t from-[#07080B]/70 via-transparent to-transparent"
                  aria-hidden="true"
                />
                <figcaption className="coordinate-badge absolute bottom-4 left-4">
                  {imageAlt}
                </figcaption>
              </figure>
            </div>
          </Reveal>
        )}
      </div>
    </header>
  );
}
